// NOTE: any configuration of easing function (goes from 0 to 1)
export type EasingFunction = (progress: number) => number;

export const linear: EasingFunction = (progress) => progress;
export const easeInCubic: EasingFunction = (progress) => progress ** 3;
export const easeOutCubic: EasingFunction = (progress) => 1 - (1 - progress) ** 3;
